export { ClampedText, type ClampedTextProps } from "./ClampedText";
